<template>
    <div>
        <div class="breadcrumb-layout" name="head-block" v-if="hiddenTree == null">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                <el-breadcrumb-item>资产维保记录</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div name="tree-block" class="org-tree-layout" :class="{'active' : !treeCollapse}" v-if="hiddenTree == null">
            <swb-popover-org-tree :showIncludeSubComs="true" :initIncludeSubComs="initIncludeSubComs" @notity-change="checkComCatChange($event)"></swb-popover-org-tree>
        </div>
        <div v-if="tmpNo != null" name="tmpNo-block">
            <div class="form-single">
                <div class="title">资产描述全称</div>
                <div class="content">
                    <label class="mr20">{{shopDeviceSvcSubNoInfo.title || ''}}</label>
                </div>
            </div>
            <div class="form-single">
                <div class="title">系统编号</div>
                <div class="content">
                    <label class="mr20">{{shopDeviceSvcSubNoInfo.tmpNo || ''}}</label>
                </div>
            </div>
        </div>
        <div name="query-sort-block">
            <swb-query-sort-area ref="query_model_ctrl" v-show="hiddenTree == null && showQuery" :confKey="confKey" :configAuto="true" :onConfigReady="onConfigReady" :queryHandler="queryHandler"></swb-query-sort-area>
        </div>
        <div class="simple-row" name="btn-block">
            <div class="right">
                <button class="swb-btn swb-btn-small" @click="download()">
                    <span>导出excel</span>
                </button>
            </div>
        </div>
        <el-tabs name="tabs-block" v-model="activeName" @tab-click="handleClick" v-if="servcType == null">
            <el-tab-pane label="维修记录" name="repairRec"></el-tab-pane>
            <el-tab-pane label="资产保养" name="maintPlan"></el-tab-pane>
        </el-tabs>
        <swb-result-table name="result_table" ref="result_table" :confKey="resultKey" :configAuto="true" :needPager="needPager" :multiSelect="multiSelect" :multiPageSelect="multiPageSelect" :rowKeyPropName="rowKeyPropName" :rowNoShow="rowNoShow" :rowNoFixed="rowNoFixed" :height="tableHeight" :pageNoChangeHandler="pageNoChangeHandler" :rowDblClickHandler="rowDblClickHandler"></swb-result-table>
    </div>
</template>

<script>
    import { Utils, $ } from '../../app.base'
    import { Vue, MsgBox, Routes, DomSizeWatcher, showPageRangeSelDlg } from '../../app.vues'
    import { getDefaultPageSizes, getDefaultDownloadPageSize } from '../../app.conf'
    import { setAssetsGroupDevcFilter } from '../asset/selectDlg'
    import { showGrpDownloadDlg } from '../ctrl/dialog'
    import { openBigImgDlg } from '../comn/dialog'
    import { loadRetailerDevcGroupList, loadRetailerShopTagList } from '../retailer/asset-comn'

    import servcDelivApi from '../../api/servcDeliv'
    import devcApi from '../../api/devc'
    import retailerApi from '../../api/retailer'
    import userApi from '../../api/user'
    import SwbResultColConf from '../query/ResultColConf.vue';
    import SwbResultTable from '../query/ResultTable.vue';

    Vue.regist(SwbResultColConf);
    Vue.regist(SwbResultTable);
    //

    export default {
        name: 'swb-device-repair-rec-info',
        path: '/device/repair/rec/list',
        avlActions: '',
        avlScopes: 'retailer',
        authen: false,
        desc: '资产-【维保记录】',
        props: ["hiddenTree", "tmpNo", "showRepairRec", "showMaintPlan", "maintPlanId", "servcType"],
        data: function () {
            return {
                confKey: "swb-device-repair-rec-info",
                resultKey: "swb-device-repair-rec-info",
                tableHeight: 300,
                //
                needPager: true, //是否需要分页（默认：true）
                multiSelect: false, //是否多选（默认：false）
                multiPageSelect: true, //是否要多页/跨页选择（默认：false）
                rowKeyPropName: "id", //记录数据关键标识列名（多页/跨页选择必须，默认: id）
                rowNoShow: false, //是否显示行号（默认：true）
                rowNoFixed: false, //行号列是否固定（默认：false）

                pageNumber: 1,
                totalCount: 0,
                pageSize: null,
                pageSizes: getDefaultPageSizes(),
                //
                queryKey: null,
                queryModel: {
                    filterItems: {},
                    sortItemList: [],
                    sortItems: {}
                },
                multipleSelection: [],
                multipleSelectionMain: [],
                exportParmas: {},
                //
                shopDeviceSvcSubNoInfo: {},
                servcWorkVoucherList: [],
                emgLevelMap: getEnumMap('emgLevel', 'value2text'),
                activeName: "repairRec",
                currShowRepairRec: true,
                currShowMaintPlan: true,
                //
                workAssignState: [],
                repairTypeList: [],
                //
                enableSearch: true,
                isClickEvent: true,
                thisComId: null,
                treeCollapse: true,
                includeSubComs: false,
                initIncludeSubComs: false,
                comLevel: null,
                selectComId: null,
                currentComId: null,
                shopFlag: false,
                showQuery: true,
                lastPageNumber: null,
            }
        },
        created: function () {
            this.pageSize = this.pageSizes.first();
            if(this.tmpNo != null || this.maintPlanId != null) {
                this.tableHeight = 500;
            }
            //
            this.workAssignState = getEnumMap("workAssignState", "value2text");
            this.repairTypeList = getEnumMap("repairType", "value2text");
            //
            if(Utils.isTrue(this.hiddenTree)) {
                if(!this.showRepairRec) {
                    this.activeName = "maintPlan";
                } else if(!this.showMaintPlan) {
                    this.activeName = "repairRec";
                }
            }
            this.getUserInfo();
            if(!Utils.isNoB(this.tmpNo)) {
                this.getShopDeviceSvcSubNo();
            }
            this.getServcWorkVoucherByTmpNo();
        },
        mounted() {
            let self = this;
            //注册domSizeWatcher
            let thisEl = $(this.$el);
            $(this.$el).addClass('overflow-hidden');
            //
            if(this.tmpNo == null && this.maintPlanId == null) {
                let domSizeWatcher = this.domSizeWatcher = new DomSizeWatcher(Vue.$getClassInfo(this).name);
                domSizeWatcher.setBaseEl(thisEl);
                domSizeWatcher.setMainEl(thisEl.find('[name="result_table"]'), function (width, height, theEl) {
                    //根据新主元素的内容大小，调整表格高度
                    self.tableHeight = height;

                });
                //domSizeWatcher.setHrEls();
                domSizeWatcher.setVtEls(thisEl.find('[name="head-block"],[name="tree-block"],[name="tmpNo-block"],[name="btn-block"],[name="tabs-block"],[name="query-sort-block"]'));
                domSizeWatcher.start(500);
            }
            //
            this.initResultTable();

        },
        destroyed() {
            //释放domSizeWatcher
            let domSizeWatcher = this.domSizeWatcher;
            if(domSizeWatcher != null) {
                domSizeWatcher.clear();
                this.domSizeWatcher = null;
            }
        },
        methods: {
            onConfigReady: function () {
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                //
                self.resultColConf = {};
                if(this.activeName == "maintPlan") {
                    let requestDescItem = {
                        requestDesc: {hidden: true}
                    };
                    query_model_ctrl.updateFields(requestDescItem);
                    //
                    let troubleDescItem = {
                        troubleDesc: {hidden: true}
                    };
                    query_model_ctrl.updateFields(troubleDescItem);
                    //
                    let faultTypeNameItem = {
                        faultTypeName: {hidden: true}
                    };
                    query_model_ctrl.updateFields(faultTypeNameItem);
                    //
                    let faultDescItem = {
                        faultDesc: {hidden: true}
                    };
                    query_model_ctrl.updateFields(faultDescItem);
                } else {
                    let requestDescItem = {
                        requestDesc: {hidden: false}
                    };
                    query_model_ctrl.updateFields(requestDescItem);
                    //
                    let troubleDescItem = {
                        troubleDesc: {hidden: false}
                    };
                    query_model_ctrl.updateFields(troubleDescItem);
                    //
                    let faultTypeNameItem = {
                        faultTypeName: {hidden: false}
                    };
                    query_model_ctrl.updateFields(faultTypeNameItem);
                    //
                    let faultDescItem = {
                        faultDesc: {hidden: false}
                    };
                    query_model_ctrl.updateFields(faultDescItem);
                }
                // 门店标签
                loadRetailerShopTagList(function (dataList) {
                    self.updateQueryModelField("buyerShopTagId", dataList);
                });
                // 分类分组
                loadRetailerDevcGroupList(function (dataList) {
                    self.updateQueryModelField("devcGroupId", dataList);
                });
            },
            updateQueryModelField: function (itemCode, dataList = []) {
                if(itemCode != null) {
                    let query_model_ctrl = this.$refs['query_model_ctrl'];
                    let data = {dataList: dataList};
                    let fieldInfo = {};
                    fieldInfo[itemCode] = data;
                    query_model_ctrl.updateFields(fieldInfo);
                }
            },
            //
            initResultTable(){
                let self = this;
                let query_model_ctrl = this.$refs['query_model_ctrl'];
                let resultTable = this.$refs['result_table'];
                //关联[列配置对象]到结果表格（结果表格可以实时利用最新的列配置，同时结果表格列宽也会反向同步到[列配置对象]中去）
                resultTable.setQrySortRef(query_model_ctrl);
                //
                resultTable.initMeta(/* confColList, */ /* 单元格html渲染函数 */{
                    'imgs': function (row, colName, colValue, rowIndex, colConf) {
                        return '<span><a class="table-cell-link" >' + colValue + '</a></span>';
                    },
                    'servcReqVoucher': function (row, colName, colValue, rowIndex, colConf) {
                        let domHtml = '';
                        if(row.servcReqVoucher != null && row.servcReqVoucher.fileBrowseUrlList != null && row.servcReqVoucher.fileBrowseUrlList.length > 0) {
                            row.servcReqVoucher.fileBrowseUrlList.forEach(function (img) {
                                domHtml = domHtml + '<a name="' + img + '"><img style="height: 36px;width: 36px" src="' + img + '"/></a>';
                            });
                        }
                        return domHtml;
                    },
                    'servcWorkImgFileList': function (row, colName, colValue, rowIndex, colConf) {
                        let domHtml = '';
                        if(row.servcWorkImgFileList != null && row.servcWorkImgFileList.length > 0) {
                            row.servcWorkImgFileList.forEach(function (img) {
                                domHtml = domHtml + '<a name="' + img.fileBrowseUrl + '"><img style="height: 36px;width: 36px" src="' + img.fileBrowseUrl + '"/></a>';
                            });
                        }
                        return domHtml;
                    },
                    'emgLevelName': function (row, colName, colValue, rowIndex, colConf) {
                        if(row.emgLevel === 0) {
                            return '<span class="swb-tags swb-tags-success">' + self.emgLevelMap[row.emgLevel] + '</span>';
                        } else if(row.emgLevel === 1) {
                            return '<span class="swb-tags swb-tags-warning">' + self.emgLevelMap[row.emgLevel] + '</span>';
                        } else {
                            return '<span class="swb-tags swb-tags-danger">' + self.emgLevelMap[row.emgLevel] + '</span>';
                        }
                    },
                    'evalFlag': function (row, colName, colValue, rowIndex, colConf) {
                        if(colValue) {
                            return '<span class="font-green">是</span>';
                        } else {
                            return '<span>否</span>';
                        }
                    }
                }, /* 单元格按钮点击处理函数 */{
                    //*代表可处理未指定事件函数的任意列的按钮/链接的点击
                    'servcReqVoucher': function (row, colName, colValue, rowIndex, btnName) {
                        self.viewImage(btnName);
                    },
                    'servcWorkImgFileList': function (row, colName, colValue, rowIndex, btnName) {
                        self.viewImage(btnName);
                    }
                });
            },
            renderTable(rows, pagination) {
                let resultTable = this.$refs.result_table;
                let tableData = {
                    rows: rows,
                    pagination: pagination
                };
                resultTable.render(tableData);
            },
            // 单元格点击事件
            rowDblClickHandler: function (row) {
                if(!this.multiSelect) {
                    console.log("----- 双击数据行 ----");
                    console.log(row);
                }
            },
            getTableSelection() {
                let resultTable = this.$refs.result_table;
                return resultTable.getSelection();
            },
            queryHandler: function (queryModel) {
                this.queryModel = queryModel;
                this.pageNumber = 1;
                this.lastPageNumber = null;
                this.getServcWorkVoucherByTmpNo();
            },
            pageNoChangeHandler: function (pageNumber, pageSize) {
                console.log("分页 => 第【" + pageNumber + "】页，大小：" + pageSize);
                //
                this.pageSize = pageSize;
                this.pageNumber = pageNumber;
                this.lastPageNumber = null;
                //
                this.getServcWorkVoucherByTmpNo();
            },
            checkComCatChange: function (eventData) {
                let self = this;
                self.comLevel = eventData.level;
                self.selectComId = eventData.id;
                self.includeSubComs = eventData.includeSubComs;
                self.getServcWorkVoucherByTmpNo();
            },
            showTreeCollapse: function (treeCollapse) {
                this.treeCollapse = treeCollapse;
            },
            // 获取设备信息
            getShopDeviceSvcSubNo: function () {
                let self = this;
                let postData = {};
                postData.no = this.tmpNo;
                let theLoad = MsgBox.loading();
                devcApi.getShopDeviceByNo(postData, function (result) {
                    theLoad.hide();
                    if(result.type === "info") {
                        //
                        self.shopDeviceSvcSubNoInfo = result.data || {};
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            //
            handleSizeChange: function (val) {
                let curStartIndex = (this.pageNumber - 1) * this.pageSize;
                this.pageSize = val;
                let newPageNumber = Math.max(1, Math.ceil(curStartIndex / this.pageSize));
                this.handlePageChange(newPageNumber);
            },
            handlePageChange: function (val) {
                this.pageNumber = val;
                this.getServcWorkVoucherByTmpNo();
            },
            handleClick(){
                this.lastPageNumber = null;
                let self = this;
                let queryModel = this.queryModel;
                let filterItems = queryModel.filterItems;
                //
                if(this.activeName == "maintPlan") {
                    filterItems.requestDesc = null;
                    filterItems.troubleDesc = null;
                    filterItems.faultTypeName = null;
                    filterItems.faultDesc = null;
                    filterItems.state = null;
                    //
                    if(this.hiddenTree == null) {
                        self.resultKey = "swb-device-repair-rec-info-2";
                    } else {
                        self.resultKey = "swb-device-repair-rec-info-3";
                    }
                } else {
                    filterItems.state = null;
                    if(this.hiddenTree == null) {
                        self.resultKey = "swb-device-repair-rec-info";
                    } else {
                        self.resultKey = "swb-device-repair-rec-info-1";
                    }
                }
                this.handlePageChange(1);
            },
            getServcWorkVoucherByTmpNo: function () {
                let self = this;
                let postData = {};
                postData.pagination = {
                    pageSize: self.pageSize,
                    pageNumber: self.pageNumber
                };

                let queryModel = self.queryModel;
                let filterItems = Utils.merge({}, queryModel.filterItems);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                filterItems.buyerShopId = this.selectComId;
                filterItems.comLevel = this.comLevel || null;
                filterItems.includeSubComs = this.includeSubComs;
                let state = filterItems.state;
                let closeValue = getEnumInfoWith('workAssignState', 'name', 'Closed').value;
                if(state == closeValue) {
                    filterItems.closed = true;
                } else {
                    filterItems.closed = false;
                }
                if(!Utils.isNoB(filterItems.state)) {
                    let stateInfo = getEnumInfoWith('workAssignState', 'value', filterItems.state);
                    if(stateInfo != null) {
                        filterItems.invalid = false;
                        if(stateInfo.name == 'Invalid') {
                            filterItems.state = null;
                            filterItems.invalid = true;
                        } else if(stateInfo.name == 'Evaluated') {
                            filterItems.evalFlag = true;
                        }
                    }
                }
                if(!Utils.isNoB(this.tmpNo)) {
                    filterItems.tmpNo = this.tmpNo;
                } else {
                    filterItems.tmpNo = "LSSB";
                }
                if(!Utils.isNoB(this.maintPlanId)) {
                    filterItems.maintPlanId = this.maintPlanId;
                }
                if(!Utils.isNoB(this.servcType)) {
                    filterItems.servcType = this.servcType;
                } else {
                    let activeName = self.activeName;
                    if(activeName == "repairRec") {
                        filterItems.maintFlag = false;
                    } else {
                        filterItems.maintFlag = true;
                    }
                }
                //
                filterItems.deviceFlag = true;
                //
                self.exportParmas = filterItems;
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                let theLoading = MsgBox.loading();
                servcDelivApi.getServcWorkVoucherByTmpNo(postData, function (result) {
                    theLoading.close();
                    self.showQuery = true;
                    if(result.type === "info") {
                        self.servcWorkVoucherList = result.data.rows || [];
                        //
                        let pagination = result.data.pagination;
                        self.totalCount = pagination.totalCount;
                        self.pageNumber = pagination.pageNumber;
                        self.pageSize = pagination.pageSize;
                        self.renderTable(result.data.rows, pagination);
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },

            handleSelectionChange(val) {
                this.multipleSelection = val;
            },

            handleSelectionMainChange(val) {
                this.multipleSelectionMain = val;
            },
            //
            getUserInfo() {
                let self = this;
                userApi.getUserInfoByContext({}, function (result) {
                    if(result.type == 'info') {
                        self.shopFlag = result.data.scopeEntity.shopFlag;
                    }
                });
            },
            getRetailerShopTagList (callback) {
                let loading = MsgBox.loading();
                retailerApi.getRetailerShopTagListByContext({}, function (result) {
                    loading.close();
                    if(result.type == "info") {
                        let retailerShopTagList = result.data;
                        let showTagList = [];
                        if(!Utils.isNoB(retailerShopTagList) && retailerShopTagList.length > 0) {
                            retailerShopTagList.forEach(function (item) {
                                showTagList.push({
                                    value: item.id,
                                    label: item.name
                                });
                            });
                        }
                        callback(showTagList);
                        //
                    } else {
                        MsgBox.warning(result.message);
                    }
                })
            },
            // 查看图片详情
            viewImage(fileBrowseUrl) {
                openBigImgDlg(fileBrowseUrl);
            },
            //
            download: function () {
                let self = this;
                let pageSize = getDefaultDownloadPageSize();
                let pages = Math.ceil(this.totalCount / pageSize);
                if(pages > 10) {
                    showPageRangeSelDlg("选择导出文件序号", pages, 10, this.lastPageNumber, function (ok, range) {
                        if(ok) {
                            if(range.to == pages) {
                                self.lastPageNumber = 0;
                            } else {
                                self.lastPageNumber = range.to;
                            }
                            //
                            self.exportPrintData(pageSize, range.from, range.to);
                        }
                    }, {pageSize: pageSize})
                } else {
                    self.exportPrintData(pageSize);
                }
            },
            exportPrintData(pageSize, fromPages, toPages){
                let title = null;
                if(this.servcType != null) {
                    if(this.servcType == 0 || this.servcType == -1) {
                        title = "维修记录";
                    } else if(this.servcType == 1) {
                        title = "保养记录";
                    } else if(this.servcType == 2) {
                        title = "安装记录";
                    } else if(this.servcType == 6) {
                        title = "检验记录";
                    }
                } else {
                    if(this.activeName == "repairRec") {
                        title = "维保记录";
                    } else {
                        title = "资产保养";
                    }
                }
                let totalCount = this.totalCount;
                let multipleSelection = [];
                if(this.activeName == "repairRec") {
                    multipleSelection = this.getTableSelection();
                    if(multipleSelection.length > 0) {
                        totalCount = multipleSelection.length;
                    }
                }
                let pages = Math.ceil(totalCount / getDefaultDownloadPageSize());
                fromPages = fromPages == null ? 1 : fromPages;
                toPages = toPages == null ? pages : toPages;
                let tableData = this.getTableData(pages, pageSize);
                //
                let url = getAppUrl("/file/export/as/excel");
                let downloadUrls = [];
                for(let i = fromPages; i <= toPages; i++) {
                    let tmpFile = {};
                    tmpFile.url = url;
                    tmpFile.post = true;
                    tmpFile.fileName = title + (pages == 1 ? '' : ("_" + (i)));
                    tmpFile.seqNo = i;
                    //
                    let data = Utils.merge({}, tableData);
                    data.pageNumber = i;
                    data.fileName = tmpFile.fileName;
                    tmpFile.data = data;
                    downloadUrls.push(tmpFile);
                }
                title = title + '-下载 | 每个文件' + pageSize + '条数据';
                showGrpDownloadDlg(title, downloadUrls);
            },
            getTableData(pages, pageSize){
                let resultTable = this.$refs.result_table;
                let tableData = resultTable.getTableData(true);
                let cols = tableData.cols || [];
                for(let i = cols.length - 1; i >= 0; i--) {
                    let col = cols[i];
                    if(col.name == "imgs") {
                        cols.splice(i, 1);
                    }
                    if(col.name == "servcReqVoucher") {
                        cols.splice(i, 1);
                    }
                    if(col.name == "servcWorkImgFileList") {
                        cols.splice(i, 1);
                    }
                }
                delete tableData.rows;//减少数据传输量
                //
                let rowsSrc = {};
                rowsSrc.data = this.getPostData();
                rowsSrc.url = "/servcDeliv/servc/work/voucher/list/get/by/tmpNo";
                tableData.rowsSrc = rowsSrc;
                //
                tableData.pageSize = pageSize;
                tableData.pageCount = this.totalCount;
                tableData.pages = pages;
                return tableData;
            },
            getPostData(){
                let queryModel = this.queryModel;
                let filterItems = Utils.merge({}, this.exportParmas);
                let sortItemList = Utils.merge([], queryModel.sortItemList);
                let sortItems = Utils.merge({}, queryModel.sortItems);
                //
                if(this.activeName == "repairRec") {
                    let ids = [];
                    let multipleSelection = this.getTableSelection();
                    multipleSelection.forEach(function (el) {
                        ids.push(el.id);
                    });
                    filterItems.ids = ids;
                }
                //
                let postData = {};
                filterItems.exportFlag = true;
                postData.filterItems = filterItems;
                postData.sortItemList = sortItemList;
                postData.sortItems = sortItems;
                //
                return postData;
            },

        }
    }
</script>




// WEBPACK FOOTER //
// src/compo/workVoucher/DeviceRepairRec.vue